import emptyFolder from './emptyFolder';
import { getFocusedFilterForTable, getViewFilterForTable, TableView } from 'owa-mail-list-store';
import { ActionSource } from 'owa-mail-store';
import folderStore, { Folder } from 'owa-folders';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { action, select } from 'satcheljs/lib/legacy';
import { isDeletedItemsFolderFromAnyMailbox, isDumpsterFolderFromAnyMailbox } from 'owa-mail-store';

export interface EmptyTableViewState {
    folderToBeEmptied: Folder;
}

export default action('emptyTableView')(
    select({
        folderToBeEmptied: tableViewToBeEmptied =>
            folderStore.folderTable.get(tableViewToBeEmptied.tableQuery.folderId),
    })(function emptyTableView(
        tableViewToBeEmptied: TableView,
        isExplicitSoftDelete: boolean,
        actionSource: ActionSource,
        rowKeysToExclude: string[],
        state?: EmptyTableViewState
    ) {
        const { folderToBeEmptied } = state;

        // Use server folder id for empty table view if it's not deleteditems or junkemail or dumpster.
        // For deleteditems or junkemail or dumpster, they don't support delete all with a viewFilter specified.
        if (
            isDumpsterFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            isDeletedItemsFolderFromAnyMailbox(folderToBeEmptied.FolderId.Id) ||
            folderToBeEmptied.DistinguishedFolderId === 'junkemail'
        ) {
            emptyFolder(
                folderToBeEmptied,
                FocusedViewFilter.None,
                'All',
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                tableViewToBeEmptied.selectAllModeTimeStamp,
                tableViewToBeEmptied.id
            );
        } else {
            // Copy properties from folderToBeEmptied to folder
            const folder: Folder = { ...folderToBeEmptied };
            folder.FolderId = {
                Id: tableViewToBeEmptied.serverFolderId,
            };
            folder.TotalCount = tableViewToBeEmptied.totalRowsInView;

            emptyFolder(
                folder,
                getFocusedFilterForTable(tableViewToBeEmptied),
                getViewFilterForTable(tableViewToBeEmptied),
                isExplicitSoftDelete,
                actionSource,
                rowKeysToExclude,
                tableViewToBeEmptied.selectAllModeTimeStamp,
                tableViewToBeEmptied.id
            );
        }
    })
);
